import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemText, Tooltip } from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';
import { SUPPORTED_LANGUAGES } from '../i18n/languages';
import { useTranslation } from '../i18n/LanguageContext';

const LanguageSelector: React.FC = () => {
  const { language, setLanguage } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const current = SUPPORTED_LANGUAGES.find(l => l.code === language) ?? SUPPORTED_LANGUAGES[0];

  return (
    <>
      <Tooltip title="Language / Idioma / Langue / Язык / 语言 / 언어">
        <IconButton
          onClick={(e) => setAnchorEl(e.currentTarget)}
          size="small"
          sx={{
            color: '#c9a86a',
            border: '1px solid rgba(201,168,106,0.35)',
            borderRadius: '6px',
            px: 1,
            py: 0.5,
            gap: 0.5,
            fontSize: '0.85rem',
            '&:hover': {
              borderColor: '#c9a86a',
              backgroundColor: 'rgba(201,168,106,0.08)',
            },
          }}
        >
          <TranslateIcon fontSize="small" />
          <span style={{ marginLeft: 4, fontSize: '0.9rem' }}>{current.flag}</span>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: {
              backgroundColor: '#1a1614',
              border: '1px solid rgba(201,168,106,0.3)',
              backgroundImage: 'none',
            },
          },
        }}
      >
        {SUPPORTED_LANGUAGES.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={lang.code === language}
            onClick={() => {
              setLanguage(lang.code);
              setAnchorEl(null);
            }}
            sx={{
              color: lang.code === language ? '#c9a86a' : '#d8d0c4',
              fontWeight: lang.code === language ? 700 : 400,
              '&.Mui-selected': {
                backgroundColor: 'rgba(201,168,106,0.12)',
              },
              '&:hover': {
                backgroundColor: 'rgba(201,168,106,0.08)',
              },
            }}
          >
            <span style={{ marginRight: 10, fontSize: '1rem' }}>{lang.flag}</span>
            <ListItemText primary={lang.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
